import { usePlatformStreamStore, type StreamingPlatform } from '@features/streaming';
import { Panel, Toggle } from '@shared/ui';

export function PlatformTogglesPanel() {
  const destinations = usePlatformStreamStore((state) => state.destinations);
  const togglePlatform = usePlatformStreamStore((state) => state.togglePlatform);
  const streamState = usePlatformStreamStore((state) => state.state);
  const disabled = streamState === 'starting' || streamState === 'live' || streamState === 'stopping';

  const platforms: { id: StreamingPlatform; label: string }[] = [
    { id: 'youtube', label: 'YouTube' },
    { id: 'twitch', label: 'Twitch' },
    { id: 'kick', label: 'Kick' },
    { id: 'custom', label: 'Custom RTMP' },
  ];

  return (
    <Panel title="STREAM PLATFORMS">
      <div className="space-y-4">
        {platforms.map((platform) => {
          const isEnabled = destinations[platform.id]?.enabled ?? false;
          return (
            <div key={platform.id} className="flex items-center justify-between py-1 transition-all duration-200">
              <Toggle
                checked={isEnabled}
                onChange={(checked) => togglePlatform(platform.id, checked)}
                label={platform.label}
                disabled={disabled}
              />
              {isEnabled && (
                <span
                  className={`h-2.5 w-2.5 rounded-full border border-surface-border transition-all duration-300 ${
                    streamState === 'live'
                      ? 'bg-status-success animate-pulse shadow-[0_0_8px_#10B981]'
                      : streamState === 'starting'
                        ? 'bg-status-warning animate-pulse shadow-[0_0_8px_#F59E0B]'
                        : 'bg-text-muted shadow-none'
                  }`}
                  title={
                    streamState === 'live'
                      ? 'Live streaming active'
                      : streamState === 'starting'
                        ? 'Starting stream...'
                        : 'Waiting for stream'
                  }
                />
              )}
            </div>
          );
        })}
      </div>
    </Panel>
  );
}
